import localStore from 'utils/localStore';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

export default function isReadMode() {
  return JSON.parse(localStore.get(STORAGE_KEYS.USER_ACCESS)) === 'READ';
}
